<template>
    <div class="err_page">
        <div class="body">
            <img src="../../../../assets/refund/ic_wangluo@2x.png" alt="">
            <p class="title">网络异常</p>
            <p class="content">请检查网络连接情况后再试</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex'
export default {
    name: "errPage",
    components: {},
    data() {
        return {
            
        };
    },
    computed: {
    },
    watch: {},
    methods: {
        
    },
    created() {
        
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.err_page {
    width: 100%;
    min-height: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
    // padding-bottom: 90px;
    font-family: PingFangSC-Regular;
    // padding-top: 56px;
    padding: env(safe-area-inset-bottom); /* zero for all rectangular user agents */
    padding: env(Safe-area-inset-bottom); /* 50px because UA properties are case sensitive */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .body{
        text-align: center;
        img{
            display: inline-block;
            width: 88px;
            height: 84px;
            margin-bottom: 36px;
        }
        .title{
            color: #333333;
            font-size: 16px;
            margin-bottom: 11px;
        }
        .content{
            color: #999999;
        }
    }
    
}

</style>